module.exports = __webpack_public_path__ + "static/img/home2.3623b32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/dynamicRoute1/home/testpage/home2.jpg
// module id = 851f
// module chunks = 163